module.exports = __webpack_public_path__ + "img/brand1.67997088.jpg";